var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMtd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 7H8.75C6.817 7 5.25 8.567 5.25 10.5V35C5.25 36.933 6.817 38.5 8.75 38.5H33.25C35.183 38.5 36.75 36.933 36.75 35V10.5C36.75 8.567 35.183 7 33.25 7Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 3.5V10.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5V10.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 17.5H36.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8008 23.8418H16.2412V28.373C16.2412 28.9655 16.1891 29.4212 16.085 29.7402C15.945 30.1569 15.6911 30.4922 15.3232 30.7461C14.9554 30.9967 14.4704 31.1221 13.8682 31.1221C13.1618 31.1221 12.6182 30.9251 12.2373 30.5312C11.8564 30.1341 11.6644 29.5531 11.6611 28.7881L13.0234 28.6318C13.0397 29.042 13.0999 29.3317 13.2041 29.501C13.3604 29.7581 13.598 29.8867 13.917 29.8867C14.2393 29.8867 14.4671 29.7956 14.6006 29.6133C14.734 29.4277 14.8008 29.0452 14.8008 28.4658V23.8418ZM24.2393 31H22.667L22.042 29.374H19.1807L18.5898 31H17.0566L19.8447 23.8418H21.373L24.2393 31ZM21.5781 28.168L20.5918 25.5117L19.625 28.168H21.5781ZM25.0254 31V23.8418H26.4316L29.3613 28.6221V23.8418H30.7041V31H29.2539L26.3682 26.332V31H25.0254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtd);
export default __webpack_public_path__ + "static/media/MTD.161aa89bf12d39a2371472259efd11d9.svg";
export { ForwardRef as ReactComponent };